import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React, { createContext, useContext } from 'react'

import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import { sessionsClient } from '../../../../utils/apollo/api'
import StatePresenter from '../../../../packages/kiti/components/helpers/StatePresenter'
import LazyAction from '../../../../components/helpers/LazyAction'

const Context = createContext()
const { Provider } = Context
export const useWebhookState = () => useContext(Context) || {}
export const useWebhooks = () => useWebhookState()?.publicTokens || []

const QUERY = gql`
  query PublicTokens($page: Int, $search: String, $sort: PublicTokenSort, $filter: PublicTokenFilter) {
    publicTokens(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      type
      action
      amountLeft
      token
      insertedAt
      enabled
    }
  }
`

const WebhookLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'ACTION', type: type || 'DESC' },
      filter: { actions: ['stays'], includeDisabled: true, ...filter }
    },
    client: sessionsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default WebhookLoader
